var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appFooter"},[_c('div',{class:[
      'footer-state',
      _vm.footerMessageIcon ]},[_vm._v(" "+_vm._s(_vm.footerMessage)+" ")]),_c('div',{staticClass:"footer-code"})])}
var staticRenderFns = []

export { render, staticRenderFns }